const AspectInputAttributeClass = {
	STATE: 'State',
	MANIPULATED: 'Manipulated'
};

export default AspectInputAttributeClass;
